(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pps-revamp-styles"] && !Shopify.designMode) return;
  try {
    (() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
  const instances = new Map();
  function mount(section) {
    if (instances.has(section) || reduceMotion.matches || window.Shopify?.designMode) return;
    const controller = new AbortController();
    const targets = [...section.querySelectorAll('.ppsr-heading-row, .ppsr-path, .ppsr-sample, .ppsr-process-intro, .ppsr-step, .ppsr-performance-main, .ppsr-performance-side, .ppsr-fabric-copy, .ppsr-fabric-art, .ppsr-materials, .ppsr-distributor-copy, .ppsr-distributor-art, .ppsr-story')];
    const observer = new IntersectionObserver(entries => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        entry.target.classList.add('ppsr-visible');
        entry.target.classList.remove('ppsr-pending');
        observer.unobserve(entry.target);
      }
    }, { threshold: 0.12, rootMargin: '0px 0px -28px 0px' });
    targets.forEach((target, index) => {
      target.style.setProperty('--ppsr-delay', `${(index % 3) * 75}ms`);
      target.classList.add('ppsr-reveal');
      if (target.getBoundingClientRect().top >= window.innerHeight) target.classList.add('ppsr-pending');
      else target.classList.add('ppsr-visible');
      observer.observe(target);
    });
    section.addEventListener('focusin', event => {
      const target = event.target.closest('.ppsr-pending');
      if (target) { target.classList.remove('ppsr-pending'); target.classList.add('ppsr-visible'); observer.unobserve(target); }
    }, { signal: controller.signal });
    const frames = new Set();
    if (finePointer.matches) {
      section.querySelectorAll('.ppsr-path').forEach(card => {
        let frame;
        card.addEventListener('pointermove', event => {
          if (frame) { cancelAnimationFrame(frame); frames.delete(frame); }
          const bounds = card.getBoundingClientRect();
          const x = (event.clientX - bounds.left) / bounds.width - 0.5;
          const y = (event.clientY - bounds.top) / bounds.height - 0.5;
          frame = requestAnimationFrame(() => {
            frames.delete(frame);
            card.style.setProperty('--ppsr-art-x', `${x * 14}px`);
            card.style.setProperty('--ppsr-art-y', `${y * 10}px`);
          });
          frames.add(frame);
        }, { signal: controller.signal });
        card.addEventListener('pointerleave', () => {
          if (frame) { cancelAnimationFrame(frame); frames.delete(frame); }
          card.style.setProperty('--ppsr-art-x', '0px');
          card.style.setProperty('--ppsr-art-y', '0px');
        }, { signal: controller.signal });
      });
    }
    instances.set(section, () => {
      observer.disconnect(); controller.abort(); frames.forEach(cancelAnimationFrame);
      targets.forEach(target => { target.classList.remove('ppsr-pending','ppsr-reveal','ppsr-visible'); target.style.removeProperty('--ppsr-delay'); });
      section.querySelectorAll('.ppsr-path').forEach(card => { card.style.removeProperty('--ppsr-art-x'); card.style.removeProperty('--ppsr-art-y'); });
      instances.delete(section);
    });
  }
  function initialize(root = document) {
    root.querySelectorAll('.ppsr').forEach(mount);
    if (root.matches?.('.ppsr')) mount(root);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', event => {
    for (const [section, cleanup] of instances) if (event.target.contains(section)) cleanup();
  });
  reduceMotion.addEventListener('change', () => {
    for (const cleanup of [...instances.values()]) cleanup();
    if (!reduceMotion.matches) initialize();
  });
})();

(() => {
  const instances = new Map();
  function mount(root) {
    if (instances.has(root)) return;
    const controller = new AbortController();
    const on = (el, name, fn) => el.addEventListener(name, fn, { signal: controller.signal });
    let observer;
    const video = root.querySelector('.ppsr-loop-video');
    if (video) {
      const button = root.querySelector('.ppsr-loop-toggle');
      const motion = matchMedia('(prefers-reduced-motion: reduce)');
      let visible = false, pausedByUser = false, manual = false;
      const auto = () => !motion.matches && !navigator.connection?.saveData && !/^(slow-2g|2g)$/.test(navigator.connection?.effectiveType || '') && !window.Shopify?.designMode;
      const play = () => video.play()?.catch(() => {});
      const resume = () => { if (visible && !document.hidden && !pausedByUser && (manual || auto())) play(); else video.pause(); };
      video.controls = false; video.muted = true; video.setAttribute('playsinline', ''); button.hidden = false;
      const sync = () => { button.setAttribute('aria-label', video.paused ? root.dataset.play : root.dataset.pause); button.querySelector('span').textContent = video.paused ? '▶' : 'Ⅱ'; };
      on(button, 'click', () => { if (video.paused) { pausedByUser = false; manual = true; play(); } else { pausedByUser = true; video.pause(); } });
      on(video, 'play', sync); on(video, 'pause', sync);
      on(video, 'error', () => { video.controls = true; button.hidden = true; });
      on(document, 'visibilitychange', resume); on(motion, 'change', resume);
      if (navigator.connection?.addEventListener) on(navigator.connection, 'change', resume);
      if ('IntersectionObserver' in window) { observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting && entries[0].intersectionRatio >= .35; resume(); }, { threshold: [0, .35] }); observer.observe(video); }
      sync();
    }
    const tabs = [...root.querySelectorAll('[data-fabric-tab]')];
    if (tabs.length) {
      const panels = [...root.querySelectorAll('[data-fabric-panel]')];
      root.querySelector('.ppsr-materials').setAttribute('role', 'tablist');
      root.querySelectorAll('[data-fabric-fallback]').forEach(label => label.hidden = true);
      const select = index => { tabs.forEach((tab,i) => { tab.setAttribute('aria-selected', String(i === index)); tab.tabIndex = i === index ? 0 : -1; panels[i].hidden = i !== index; }); };
      tabs.forEach((tab,index) => { tab.hidden = false; tab.setAttribute('role', 'tab'); tab.closest('li').setAttribute('role', 'presentation'); panels[index].setAttribute('role', 'tabpanel'); panels[index].setAttribute('aria-labelledby', tab.id); panels[index].tabIndex = 0; on(tab, 'click', () => select(index)); on(tab, 'keydown', event => { let next; if (event.key === 'ArrowRight') next = (index+1)%tabs.length; if (event.key === 'ArrowLeft') next = (index+tabs.length-1)%tabs.length; if (event.key === 'Home') next = 0; if (event.key === 'End') next = tabs.length-1; if (next !== undefined) { event.preventDefault(); select(next); tabs[next].focus(); } }); });
      select(0);
    }
    instances.set(root, () => { controller.abort(); observer?.disconnect(); video?.pause(); instances.delete(root); });
  }
  const scan = parent => parent.querySelectorAll('[data-performance-loop], [data-fabric-tabs]').forEach(mount);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(document), { once: true }); else scan(document);
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-performance-loop], [data-fabric-tabs]').forEach(root => instances.get(root)?.()));
})();
  } catch(e) { console.error(e); }
})();

})();
